import React from 'react';
import { apiHost } from '../../../config';
import { useStatsig } from '../hooks/useStatsig';
import { withCurrentReturnTo } from '../../utils/oauthReturnTo';
import styles from '../../pages/LoginPage/Login/login.scss';

const AppleLoginV3 = ({ flow = 'login', buttonText = 'Sign In with Apple', 'data-testid': dataTestId }) => {
    const { checkGate, featureGates } = useStatsig();
    const isCampaignDeepLinkEnabled = checkGate(featureGates.POWER_CAMPAIGN_DEEP_LINK);

    const onSubmitApple = () => {
        const initiateUrl = `${apiHost}/v3/oauth/apple/initiate?platform=web&flow=${flow}`;
        window.location.href = isCampaignDeepLinkEnabled ? withCurrentReturnTo(initiateUrl) : initiateUrl;
    };

    return (
        <button
            type="button"
            className={`btn btn-primary btn-block mb16 btn-xl`}
            onClick={onSubmitApple}
            data-testid={dataTestId && `${dataTestId}.btn`}
        >
            <div className={`d-flex jcc align-items-center ${styles.appleLogin} fw600`}>
                <i className="fab fa-apple" />
                <div className="ml-2 text-uppercase" data-testid={dataTestId && `${dataTestId}.label`}>{buttonText}</div>
            </div>
        </button>
    );
};

export default AppleLoginV3;
